module.exports = __webpack_public_path__ + "img/logo-header.30e22a5a.png";